import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountRepository } from '@timechef/features/account/state';

@Component({
  selector: 'app-nutriscore-modal',
  templateUrl: './nutriscore-modal.component.html',
  styleUrls: ['./nutriscore-modal.component.scss'],
  standalone: false,
})
export class NutriscoreModalComponent {
  language$ = this.accountRepo.language$;

  constructor(
    private modalCtrl: ModalController,
    private accountRepo: AccountRepository,
  ) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
